// requestSlice.js
import { createSlice } from '@reduxjs/toolkit';

export const requestSlice = createSlice({
    name: 'requestAPI',
    initialState: {
        apiLoading: false,
        cancelSource: null,
        apiUrl: '', // This is the API URL being tracked
        // apiParams: null,
        method: '',
        resetHomePage: false,
    },
    reducers: {
        startApiLoading: (state, action) => {
            state.apiLoading = true;
            state.cancelSource = action.payload.cancelSource; // Save cancel function
            state.apiUrl = action.payload.apiUrl; // Save the API URL
            // state.apiParams = action.payload.params; // API params request
            state.method = action.payload.method;
        },
        stopApiLoading: state => {
            state.apiLoading = false;
            state.cancelSource = null;
            state.apiUrl = '';
            // state.apiParams = null;
            state.method = '';
        },
        terminateRequest: (state) => {
            // Cancel the ongoing request using the stored cancelSource
            state.resetHomePage = true;
            if (state.cancelSource) {
                try {
                    state.cancelSource.cancel('Request terminated by user');
                } catch (error) {
                    console.warn('Failed to cancel request:', error);
                }
            }
            state.apiLoading = false;
            state.cancelSource = null;
            state.apiUrl = '';
            // state.apiParams = null;
            state.method = '';
        },
        setResetHomePageToDefault: (state) => {
            state.resetHomePage = false;
        }
    },
});

export const getRequestAPIState = (state) => state.requestAPI;

export const {
    startApiLoading,
    stopApiLoading,
    terminateRequest,
    setResetHomePageToDefault
} =
    requestSlice.actions;

export default requestSlice.reducer;
